import SAPOMailConfig from "@/SAPOMailConfig";
import HTTPService    from "@/js/Shared/Services/HTTP/HTTPService";

export { SmokescreenHTTPService as default };

/**
* Smokescreen HTTP Service
*
* @author      Rúben Simoes <ruben.r.simoes@meo.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class SmokescreenHTTPService
{
    /**
     * Smokescreen Enpoint
     *
     * @public
     *
     * @type {string}
     *
     * @since 7.0.0
     */
    endpoint = SAPOMailConfig.client.endpoints.settings.imp;

    /**
     * Calls backend api to fetch smokescreen list
     *
     * @public
     *
     * @since 7.0.0
     *
     * @return {Promise.<HTTPResponseEntity>}
     */
    async fetchSmokescreenList() {
        let response = await HTTPService.post(
            this.endpoint + '/smokescreen',
            {
                'op' : 'smokescreenGet',
            },
            'fetch_smokescreen_list',
        );

        return response;
    }

    /**
     * Calls backend api to fetch smokescreen list
     *
     * @public
     *
     * @since 7.0.0
     *
     * @return {Promise.<HTTPResponseEntity>}
     */
    async addSmokescreenAddress(prefix) {
        let response = await HTTPService.post(
            this.endpoint + '/smokescreen',
            {
                'op' : 'smokescreenGenerate',
                'params' : {
                    'prefix'  : prefix,
                }
            },
            'generate_smokescreen_address',
        );

        return response;
    }

    /**
     * Calls backend api to disable smokescreen addresses
     *
     * @public
     *
     * @since 7.0.0
     *
     * @param {string[]} addresses  emails to be disabled from smokescreen
     *
     * @return {Promise.<HTTPResponseEntity>}
    */
    async disableSmokescreenAddresses(addresses) {
        let response = await HTTPService.post(
            this.endpoint + '/smokescreen',
            {
                'op'       : 'smokescreenDisable',
                'params'   : {
                'addresses': addresses
                }
            },
            `disable_smokescreen_${addresses.join('_')}`,
        );

        return response;
    }

    /**
     * Calls backend api to enable smokescreen addresses
     *
     * @public
     *
     * @since 7.0.0
     *
     * @param {string[]} addresses  emails to be enabled from smokescreen
     *
     * @return {Promise.<HTTPResponseEntity>}
    */
    async enableSmokescreenAddresses(addresses) {
        let response = await HTTPService.post(
            this.endpoint + '/smokescreen',
            {
                'op'       : 'smokescreenEnable',
                'params'   : {
                'addresses': addresses
                }
            },
            `enable_smokescreen_${addresses.join('_')}`,
        );

        return response;
    }
}